import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Global from 'models/Global';
import SessionView from 'views/SessionView';
import Config from 'config';
import sessionTemplate from 'hbars!templates/sessionView';
import template from 'hbars!templates/sessionList';

Handlebars.registerPartial('sessionView', sessionTemplate);

var AgendaSessionsView = Backbone.View.extend({

    events: {

    },

    initialize: function(options) {
        this.currentDay = options.currentDay;
        this.agenda = Global.get('agenda');
        this.sessionCollection = new Backbone.CollectionView({
            collection: this.model.get('sessions'),
            selectable: false,
            modelView: SessionView
        });

        this.listenTo(this.model.get('sessions'), 'visibilityChanged', this.visibilityChanged);
        this.listenTo(this.currentDay.get('track'), 'change:disabled', this.trackStateChanged);
        const tracks = this.currentDay.get('track');
        const tracksArray = tracks ? tracks.toArray() : [];
        this.toggleTracksVisibility(tracksArray);
    },

    visibilityChanged: function() {
        var visibleSessions = this.model.get('sessions').findWhere({isHidden: false});
        var shouldHide = visibleSessions ? false : true;
        this.$el.toggleClass('hide', shouldHide);
    },

    trackStateChanged: function(track) {
        if (this.model.get('trackId') == track.get('id')) {
            this.$el.toggleClass('hide', track.get('disabled'));
        }
    },

    toggleTracksVisibility: function(tracks) {
        const thisVIew = this;
        tracks.forEach(track => {
            thisVIew.trackStateChanged(track);
        });
    },

    remove: function() {
        this.sessionCollection.remove();
        return Backbone.View.prototype.remove.call(this);
    },

    render: function() {
        var html = template(this.model.toJSON());
        this.$el.html(html);
        this.sessionCollection.setElement(this.$('.sessions-list')).render();
        return this;
    }

});

export default AgendaSessionsView;


